import { OpenHoleLoggingCostBase } from './base/open-hole-logging-cost-base';

export class OpenHoleLoggingCost extends OpenHoleLoggingCostBase { }